export default __webpack_public_path__ + "static/media/Slide1.a9094634.png";